import { render, staticRenderFns } from "./index-categories.vue?vue&type=template&id=1ddf96ac&scoped=true"
import script from "./index-categories.vue?vue&type=script&lang=js"
export * from "./index-categories.vue?vue&type=script&lang=js"
import style0 from "./index-categories.vue?vue&type=style&index=0&id=1ddf96ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf96ac",
  null
  
)

export default component.exports